import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromUpdateInfo from './reducers/update-info.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UpdateInfoEffects } from './effects/update-info.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('updateInfo', fromUpdateInfo.reducer),
    EffectsModule.forFeature([UpdateInfoEffects])
  ]
})
export class UpdateInfoModule { }
